import { Button, ButtonProps, Stack } from '@mui/material';
import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';

type LoadMoreProps = {
    loadMore: () => void | Promise<void>;
    buttonProps?: Omit<ButtonProps, 'onClick'>;
};
const LoadMore = ({ loadMore, buttonProps }: LoadMoreProps) => {
    const [isInView, setIsInView] = useState(false);
    const ref = useRef(null);
    const { t } = useTranslation();

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                // A batch can hold stale entries from a frame before the latest layout: the last one is current.
                setIsInView(entries[entries.length - 1].isIntersecting);
            },
            { threshold: 0.5 },
        );

        const element = ref.current;
        if (element) {
            observer.observe(element);
        }

        return () => {
            if (element) {
                observer.unobserve(element);
            }
        };
    }, []);

    useEffect(() => {
        if (isInView) {
            loadMore();
        }
    }, [isInView, loadMore]);

    return (
        <Stack>
            {!buttonProps ? (
                <Stack ref={ref} height={4} />
            ) : (
                <Button {...buttonProps} onClick={loadMore}>
                    {t('str.load-more')}
                </Button>
            )}
        </Stack>
    );
};

export default LoadMore;
